import styled, { css } from 'styled-components';
import { InviteStatus } from '@common/types/invites/invite-status';

export interface InviteStatusMarkerProps {
  status: InviteStatus;
}

export const InviteStatusMarker = styled.span<InviteStatusMarkerProps>`
  width: 9px;
  min-width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-right: 10px;
  display: block;
  background-color: ${({ theme }) => theme.colors.upload};

  background-color: ${(props) =>
    props.status === 'accepted'
      ? css`
          ${({ theme }) => theme.colors.success}
        `
      : null};
  background-color: ${(props) =>
    props.status === 'pending'
      ? css`
          ${({ theme }) => theme.colors.upload}
        `
      : null};
  background-color: ${(props) =>
    props.status === 'rejected'
      ? css`
          ${({ theme }) => theme.colors.error}
        `
      : null};

  @media ${({ theme }) => theme.device.tablet} {
    margin-right: 20px;
  }
`;

export default InviteStatusMarker;
